import { render, staticRenderFns } from "./reportMsg.vue?vue&type=template&id=11851833&scoped=true&"
import script from "./reportMsg.vue?vue&type=script&lang=js&"
export * from "./reportMsg.vue?vue&type=script&lang=js&"
import style0 from "./reportMsg.vue?vue&type=style&index=0&id=11851833&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11851833",
  null
  
)

export default component.exports